import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import { DetailedIncentives, filterIncentiveIds } from 'wsm-incentive-display';
import '../global-sass/main.scss';
import { ErrorBoundary } from 'wsm-error-boundary';

export class WidgetContainer extends React.Component {
	render() {
		const { wisIncentives, account } = this.props;

		return (
			<Common
				render={({ prefs, labels }) => {
					const incentivesEnabled =
						wisIncentives &&
						Object.keys(wisIncentives).length > 0 &&
						prefs.showIncentives === 'true';
					const sidebarDisclaimer = prefs.sidebarPricingDisclaimer;
					const filteredIncentives = incentivesEnabled
						? filterIncentiveIds(
								wisIncentives,
								Object.keys(wisIncentives)
						  )
						: {};
					return (
						<ErrorBoundary newRelicPageAction="WS DETAILED INCENTIVES ERROR BOUNDARY">
							<React.Fragment>
								{incentivesEnabled && (
									<DetailedIncentives
										incentives={filteredIncentives}
										accountInfo={account}
										incentiveTitleDisplay={
											prefs.incentiveTitleDisplay
										}
										incentiveTitleCustom={
											prefs.incentiveTitleCustom
										}
										incentiveDisplayGrouping={
											prefs.incentiveDisplayGrouping
										}
										enableAccordion={
											prefs.enableAccordion === 'true'
										}
										showDealerRegularIncentives={
											prefs.showDealerRegularIncentives ===
											'true'
										}
										showDealerConditionalIncentives={
											prefs.showDealerConditionalIncentives ===
											'true'
										}
										showOemNationalIncentives={
											prefs.showOemNationalIncentives ===
											'true'
										}
										showOemConditionalIncentives={
											prefs.showOemConditionalIncentives ===
											'true'
										}
									/>
								)}
								{sidebarDisclaimer && (
									<React.Fragment>
										{labels.getHTML(sidebarDisclaimer)}
									</React.Fragment>
								)}
							</React.Fragment>
						</ErrorBoundary>
					);
				}}
			/>
		);
	}
}

WidgetContainer.propTypes = {
	wisIncentives: PropTypes.shape({
		uniqueId: PropTypes.string,
		title: PropTypes.string,
		shortTitle: PropTypes.string,
		offerDetails: PropTypes.string,
		effectiveDate: PropTypes.string,
		expirationDate: PropTypes.string,
		conditional: PropTypes.bool,
		disclaimer: PropTypes.string,
		make: PropTypes.string,
		condition: PropTypes.string,
		manufacturerOffer: PropTypes.bool,
		specific: PropTypes.shape({})
	}),
	account: PropTypes.shape({
		name: PropTypes.string,
		id: PropTypes.string
	}).isRequired,
	labels: PropTypes.shape({}).isRequired
};

WidgetContainer.defaultProps = {
	wisIncentives: {}
};

const mapStateToProps = (state) => {
	return {
		wisIncentives: state.wisIncentives,
		account: state.account,
		labels: state.labels
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
